import { ObjectSearchEnvironmentConfig } from './object-search-environment-config';

export const environment: ObjectSearchEnvironmentConfig = {
  production: true,
  apiBaseUrl: `https://search.aks.immosky.com`,
  apiBasicAuth: 'blackknight:GsKpxpdyhK25Wj.+Tzs=2u',
  googleMapsApiKey: 'AIzaSyAwPgjBAlhmrnuoAqG6s2ZOnxZWvIRyuNM',
  countries: ['CH', 'LI'],
  language: 'de',
  detailPageUrl: '/de/kaufen-mieten/{id}/',
  isResidia: false,
};
